define('StickyNav',['jquery', 'ANSI/Utility/Dimensions', 'ANSI/Utility/SitecoreUtils', 'promise-polyfill'], function ($, dimensions, sitecoreUtils) {
    'use strict';
    var stickyNav = {
        init: function () {
            if ($('.ansi-sticky-navbar').length) {
                stickyNav.scroll();
                stickyNav.steps();
                if (dimensions.width < 992) {
                    stickyNav.mobileDropdown();
                }
            }
        },
        sticky: function () {
            var navbar = document.getElementsByClassName('ansi-sticky-navbar')[0];
            var header = document.getElementsByClassName('ansi-header')[0];
            var navOffset = navbar.offsetTop;

            if (window.pageYOffset >= navOffset - 57) {
                navbar.classList.add('sticky');
                header.classList.add('pull-up');
            } else {
                navbar.classList.remove('sticky');
                header.classList.remove('pull-up');
            }
        },
        scroll: function () {
            var timeout;

            window.addEventListener(
                'scroll',
                function (event) {
                    if (timeout) {
                        window.cancelAnimationFrame(timeout);
                    }

                    timeout = window.requestAnimationFrame(function () {
                        stickyNav.sticky();
                    });
                },
                false
            );
        },
        mobileDropdown: function () {
            $('.ansi-sticky-navbar .dropdown-menu li a:not(.ansi-sticky-navbar .dropdown-menu li.sticky-nav-modal-btn a, .ansi-sticky-navbar .score-megamenu .dropdown-menu li a)').on(
                'click',
                function (e) {
                    e.preventDefault();
                    var selText = $(this).text();
                    $(this)
                        .parents('.score-button-menu')
                        .find('.btn')
                        .html(selText + '<span class="caret"></span><span class="sr-only">Toggle</span>');
                }
            );
        },
        steps: function () {
            if ($('.score-megamenu').length) {
                var text = $('.ansi-sticky-navbar .dropdown-menu').find('.active > a').text();
                var newText = text.trim().slice(0, 6);
                var menuText = $('.ansi-sticky-navbar .active-section > a:first-child');
                menuText.text(newText);
            }
        }
    };
    if (!sitecoreUtils.prototype.isEditing()) Promise.resolve().then(stickyNav.init);
});

